import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import {
  Public,
  Hotel,
  SupportAgent,
} from '@mui/icons-material';
import { ScrollReveal } from '../../animations';
import { colors } from '../../theme/colors';

const features = [
  {
    icon: <Public sx={{ fontSize: 28 }} />,
    title: 'Every kind of trip',
    description: 'Umrah, ziyarat, international holidays, and Pakistan journeys.',
  },
  {
    icon: <Hotel sx={{ fontSize: 28 }} />,
    title: 'Stay, move, eat',
    description: 'Hotels, transport, and meals bundled clearly — no guesswork.',
  },
  {
    icon: <SupportAgent sx={{ fontSize: 28 }} />,
    title: 'Human support',
    description: 'Real people help you confirm and travel with confidence.',
  },
];

const FeaturesSection = () => {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 7, md: 10 },
        background: colors.gradient.mist,
      }}
    >
      <Container maxWidth="lg">
        <ScrollReveal animation="fadeInUp">
          <Box sx={{ mb: 5, maxWidth: 480 }}>
            <Typography variant="h2" sx={{ mb: 1 }}>
              Travel, made clear
            </Typography>
            <Typography color="text.secondary">
              A simple agency experience — elegant planning without the noise.
            </Typography>
          </Box>
        </ScrollReveal>

        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} md={4} key={feature.title}>
              <ScrollReveal animation="fadeInUp" delay={index * 0.08}>
                <Box>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'rgba(31,111,120,0.12)',
                      color: colors.secondary.main,
                      mb: 2,
                    }}
                  >
                    {feature.icon}
                  </Box>
                  <Typography
                    sx={{
                      fontFamily: "'Fraunces', Georgia, serif",
                      fontWeight: 600,
                      fontSize: '1.25rem',
                      mb: 1,
                    }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography color="text.secondary" sx={{ lineHeight: 1.6 }}>
                    {feature.description}
                  </Typography>
                </Box>
              </ScrollReveal>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default FeaturesSection;
